// VehTypeGroupCodeInput.js
import React, { useEffect, useState } from 'react';
import { Button, DialogContent, DialogActions, CircularProgress } from '@mui/material';
import { AppWord, AppObject, AppStyle } from '../../value/AppConst';
import { useConfirmDialog } from '../../common/AppConfirmDialog';
import DraggableEditor from '../../common/DraggableEditor';
import InputUtil from '../../value/InputUtil';
import VzmTextField from '../../common/VzmTextField';
import { VzmInputBlock } from '../../common/VzmStyled';
import { VehTypeGroupCodeDictionary } from './VehTypeGroupCodeDict';

const InputMap = VehTypeGroupCodeDictionary.inputMap;
const defaultInputData = InputUtil.defaultValuesFromInputMap(InputMap);

/**
 * 차종그룹(VEH_TYPE_GROUP_CODE) 정보 생성 또는 편집 Dialog
 * Using React with MUI5
 * Project: NewTOP for cloud
 * 2024-08-22 10:34:22 using DbdbTap
 */
export default function VehTypeGroupCodeInput({
    open,
    item,
    onClose,
    onRequestSave,
    responseSaving, // Response if result is NOT OK.
}) {
    const [input, setInput] = useState({...AppObject.emptyInputData});
    const [isEdit, setIsEdit] = useState(false);
    const openConfirmDialog = useConfirmDialog();
    const {loading:loadingSave, error:errorSave, data:resultSave} = responseSaving; // 전송 결과에 대한 View 기능 소화.

    useEffect(()=>{
        if(open) {
            const inputSet = {...AppObject.emptyInputData};
            let editing = false;
            if(item) {
                inputSet.data = {...item};
                editing = true;
            }
            else {
                inputSet.data = {...defaultInputData};
            }
            setInput(inputSet);
            setIsEdit(editing);
        }
    }, [open, item]);

    const onChangeValue = (id, value, error) => {
        const newInput = InputUtil.reflectData(input, id, value, error, InputMap, isEdit);
        setInput(newInput);
    };

    const onClickSubmit = () => {
        const param = InputUtil.getDataToSubmit(input.data, InputMap, isEdit);
        onRequestSave(param, isEdit);
    };

    const askCancel = async () => {
        const confirm = await openConfirmDialog({
            ...AppObject.messageCancelEdit,
            option: {yesLabel: AppWord.IgnoreAndClose}
        });
        if(confirm) onClose();
    };

    const onClickCancel = () => {
        if(input.changed) askCancel();
        else onClose();
    };

    // Input field initiallized using getInputField(c,t,i)
    return(
        <DraggableEditor open={open} maxWidth='md'
            onClose={onClickCancel}
            title={isEdit ? '차종그룹 정보 수정' : '차종그룹 정보 생성'}
        >
            <DialogContent>
                <VzmInputBlock minWidth={400}>
                    <VzmTextField
                        dict={InputMap.groupName}
                        value={input.data.groupName}
                        onChange={onChangeValue}
                        fullWidth={true}
                    />
                </VzmInputBlock>
                <VzmInputBlock>
                    <VzmTextField
                        dict={InputMap.memo}
                        value={input.data.memo}
                        onChange={onChangeValue}
                        fullWidth={true}
                    />
                </VzmInputBlock>
                
            </DialogContent>
            <DialogActions>
                {
                    loadingSave
                    ?
                    <span>
                        <CircularProgress />
                        &nbsp;데이터 저장 중...
                    </span>
                    :
                    <>
                        <Button
                            onClick={onClickSubmit}
                            disabled={input.hasError || !input.changed}
                            variant={AppStyle.mui.contained}
                            color={AppStyle.mui.primary}
                        >저장</Button>
                        <Button onClick={onClickCancel}
                            color={AppStyle.mui.warning}
                            variant={AppStyle.mui.contained}
                        >취소</Button>
                    </>
                }
            </DialogActions>
        </DraggableEditor>
    );
}
